"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayMultipleCarsDetailsWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var LookupWidgetBase_1 = require("../../LookupWidgetBase");
var commonFunctions_1 = require("../../../commonFunctions");
var moment = require("moment");
var services_1 = require("@falcon/services");
var DisplayMultipleCarsDetailsWidget = /** @class */ (function (_super) {
    __extends(DisplayMultipleCarsDetailsWidget, _super);
    function DisplayMultipleCarsDetailsWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        return _this;
    }
    DisplayMultipleCarsDetailsWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: this.renderCarDetails() }));
    };
    DisplayMultipleCarsDetailsWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("vehicleTransmission");
        this.fetchLookupValues("vehicleFuelType");
    };
    DisplayMultipleCarsDetailsWidget.prototype.renderCarDetails = function () {
        var car = this.props.interaction.vehicles[this.vehicleIndex];
        var purchaseDate = car.purchaseDate ? moment(car.purchaseDate).format("MMM YYYY") : null;
        var engineSize = (0, commonFunctions_1.getVehicleEngineSize)(car);
        return ((0, jsx_runtime_1.jsxs)("div", { className: "my-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "panel-preview-area mb-3", children: [(0, jsx_runtime_1.jsx)("img", { className: "icon-lg", alt: "vehicle-icon-lg", "aria-hidden": "true", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png") }), (0, jsx_runtime_1.jsxs)("h2", { children: [car.make, ", ", car.model] }), (0, jsx_runtime_1.jsx)("div", { className: "number-plate-preview", children: car.registrationNumber })] }), (0, jsx_runtime_1.jsxs)("div", { className: "text-center font-weight-light", children: [engineSize &&
                            (0, jsx_runtime_1.jsxs)("span", { children: [engineSize, "cc ", (0, jsx_runtime_1.jsx)("br", {})] }), (0, commonFunctions_1.getVehicleNumberOfDoors)(car), " dr", (0, jsx_runtime_1.jsx)("br", {}), "Manufactured in ", car.year, (0, jsx_runtime_1.jsx)("br", {}), purchaseDate && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Purchased in ", purchaseDate, (0, jsx_runtime_1.jsx)("br", {})] }), this.resolveLookupValue("vehicleTransmission", car.transmission), (0, jsx_runtime_1.jsx)("br", {}), this.resolveLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(car.fuelType, car.fuelTypeFull))] })] }));
    };
    return DisplayMultipleCarsDetailsWidget;
}(LookupWidgetBase_1.LookupWidgetBase));
exports.DisplayMultipleCarsDetailsWidget = DisplayMultipleCarsDetailsWidget;
//# sourceMappingURL=DisplayMultipleCarsDetailsWidget.js.map